import { hostApi } from "@/apis/index";
import Vue from 'vue';


const api_user = `${hostApi}/api/users`;

function getUser(id) {
    return Vue.prototype.$http.get(`${api_user}/${id}`);
}

function updateUser(item) {
    return Vue.prototype.$http.put(`${api_user}`, item)
}

function changeUserPhone(item){
    return Vue.prototype.$http.post(`${api_user}/phoneChange`, item)
}

function changeUserPhoneCheck(item){
    return Vue.prototype.$http.post(`${api_user}/phoneChangeCheck`, item)
}

function secessionUser() {
    return Vue.prototype.$http.post(`${api_user}/secession`)
}

const api_app_user = `${hostApi}/api/app/users`;

function createUser(item) {
    return Vue.prototype.$http.post(`${api_app_user}`, item)
}

function createUserCheck(item) {
    return Vue.prototype.$http.post(`${api_app_user}/saveCheck`, item)
}

function changeUserPw(item){
    return Vue.prototype.$http.post(`${api_app_user}/pwChange`, item)
}

function changeUserPwCheck(item){
    return Vue.prototype.$http.post(`${api_app_user}/pwChangeCheck`, item)
}



export {
    getUser,
    updateUser,
    changeUserPhone,
    changeUserPhoneCheck,
    secessionUser,

    createUser,
    createUserCheck,
    changeUserPw,
    changeUserPwCheck,
};
